export default __webpack_public_path__ + "3372aeeb4f733add4388961f04cff308.svg";